import React, {useContext, useEffect, useMemo, useRef, useState} from "react"
import {useTranslation} from "next-i18next"
import LayoutContext from "../../context/LayoutContext"
import Typography from "../reusable/Typography/Typography"
import FilterHorizontalSection from "./desktopComponents/FilterHorizontalSection"
import FilterVerticalSection from "./desktopComponents/FilterVerticalSection"
import FilterModal from "./filterModalMobile/FilterModal"
import {CollectionName} from "../../constants"
import urlParams from "../../utility/UrlParams"
import {X} from "react-bootstrap-icons"
import {useRouter} from "next/router"
import {defaultValue} from "./Config"
import {filterUrl} from "./FilterUrl"
import DataContext from "../../context/DataContext"
import BannerForPartners from "../bikeDetails/BannerForPartners"
import FilterDropdownItem from "./dropdown/FilterDropdownItem"
import FilterbarMobileTabs from "./FilterbarMobileTabs"
import EmptySearchResults from "../bikesCollection/EmptySearchResults"
import BasedOnYourViews from "./BasedOnYourViews"
import BrandInfoPLP from "../brandInfoPLP/BrandInfoPLP"
import {mergeAttributeOptionsBySlug} from "../../utility/Helper"

type Props = {
	productsList: any[]
	filteredProductsLength?: number
	collectionName: CollectionName
	children: React.ReactElement
	collectionCategory?: string
	customUrlBaseValue?: string
	isSearchActive?: boolean
	isLoading:boolean
    filteredProductsList?: any[]
}

const FilterBar: React.FC<Props> = ({
	productsList,
	filteredProductsLength,
	collectionName,
	children,
	collectionCategory = "",
	customUrlBaseValue,
	isSearchActive,
	isLoading = false,
	filteredProductsList
}: Props) => {
	const {t} = useTranslation(["common", "filters"])
	const {
		bikeFilters,
		accessoryFilters,
		horizontalBikesCategoryFilters,
		productsPriceRange,
		accessoriesPriceRange
	} = useContext(DataContext)
	const router = useRouter()
	const params = router.query
	const filters = useMemo(() => params?.categories?.includes(t("accessories-url-slug")) || params?.["accessory-type"] !== undefined ? accessoryFilters : mergeAttributeOptionsBySlug(accessoryFilters, bikeFilters), [params, router])
	const priceRange = useMemo(() => params?.categories?.includes(t("accessories-url-slug")) || params?.["accessory-type"] !== undefined ? accessoriesPriceRange : productsPriceRange, [params, filters, router])
	const {isMobile, isListView} = useContext(LayoutContext)
	const isBrandWorld = router?.pathname.includes("/brand-world")
	const [searchValueButtonSpinner, setSearchValueButtonSpinner] = useState(false)
	const [isOpen, setIsOpen] = useState(false)
	const [filtersInitialised, setFiltersInitialised] = useState(false)
	const refToStartOfCollection = useRef(null)
	const categories = filters?.[0]
	const isEmptySearch = isSearchActive && filteredProductsLength === 0
	const filterSearchValue = params[urlParams.searchValue] ? params[urlParams.searchValue] !== defaultValue ? params[urlParams.searchValue] : "" : ""
	const isAccessoriesPage = Boolean(params?.categories?.includes(t("accessories-url-slug")) || params?.["accessory-type"] !== undefined)
	const executeScroll = () => refToStartOfCollection.current.scrollIntoView()
	const handleClose = () => {
		setIsOpen(false)
	}

	let brandsArray: string[] = []
	let bikeCatArray: string[] = []

	if (typeof params.brand === "string") {
		brandsArray = params.brand.split(",")
	} else if (Array.isArray(params.brand)) {
		brandsArray = params.brand
	}

	if (typeof params.categories === "string") {
		bikeCatArray = params.categories.split(",")
	} else if (Array.isArray(params.categories)) {
		bikeCatArray = params?.categories
	}

	const selectedCategory = (bikeCatArray.length === 1 && bikeCatArray[0] !== "-" && filteredProductsLength > 0) ? bikeCatArray[0] : "e_bikes"

	const handleOpen = () => {
		setIsOpen(true)
	}

	useEffect(() => {
		if (filtersInitialised && filteredProductsLength <= 12 && !isMobile && !isListView) {
			executeScroll()
		}

		if (filtersInitialised && filteredProductsLength <= 8 && !isMobile && isListView) {
			executeScroll()
		}

		if (!filtersInitialised) {
			setFiltersInitialised(true)
		}
	}, [filteredProductsLength])

	const filteredHorizontalCategories = useMemo(() => {
		return horizontalBikesCategoryFilters
	}, [params, filteredProductsList, horizontalBikesCategoryFilters])
	return (
		<>
			<div className="d-block  d-md-none plp-header">
				{isEmptySearch ? <EmptySearchResults/> : <>
					<div className="ps-12 mt-4">
						{brandsArray.length === 1 && !isBrandWorld &&
						<div className="mb-4">
							<BrandInfoPLP selectedBrand={brandsArray[0]}
								selectedCategory={selectedCategory}/>
						</div>}
					</div>
				</>}

				<div className="d-flex justify-content-center"
				>
					<BannerForPartners/>
				</div>
				<div style={{zIndex: 10000, width: "100%"}}
					className={"sticky-top bg-white shadow-sm"}>
					<div
						className={`px-0 d-none ${filterSearchValue ? "mb-2" : "mb-4"} pb-2 d-md-flex justify-content-center`}
						style={{width: "100%", overflowX: "scroll"}}>
						<ul className="px-0 d-flex align-items-center list-unstyled bike-categories ms-2"
							style={{height: 48}}>
							{categories?.options?.map((category, idx) => {
								return <div key={idx}
									className="col-auto">
									<FilterDropdownItem key={category.slug}
										isBoxShape={true}
										label={category.name}
										collectionName={collectionName}
										param={categories.slug}
										value={category.slug}/>
								</div>
							}
							)}
						</ul>
					</div>
					<FilterbarMobileTabs collectionName={collectionName}
						filters={filters}
						handleOpen={handleOpen}/>
				</div>
				{filterSearchValue && !isEmptySearch &&
					<div className=" d-flex flex-row align-items-center ps-2 ms-1 mb-4">
						<Typography variant="bodySmBold"
							className="col-auto ms-0 me-3">
							{`${t("search")}:`}
						</Typography>
						<button
							onClick={() => {
								setSearchValueButtonSpinner(true)
								const url = filterUrl(params, urlParams.searchValue, "-", collectionName)
								setTimeout(() => {
									router.push(url, undefined, {shallow: true, scroll: false}).then(() => {
										setSearchValueButtonSpinner(false)
									})
								}, 0)
							}}
							className="btn col-auto d-flex align-items-center justify-content-center me-2 mt-md-0  mb-md-0 grey-hover"
							style={{
								height: 40,
								padding: "10px 12px 10px 16px",
								borderRadius: 16,
								backgroundColor: "#212529",
								border: "1px solid #212529",
								color: "white"
							}}>
							{searchValueButtonSpinner && <span style={{color: "#fff"}}
								className="spinner-border spinner-border-sm text-white me-2"
								role="status"
								aria-hidden="true"/>}
							<Typography className="me-1"
								variant="bodySmBold">
								{decodeURI(filterSearchValue.toString())}
							</Typography>
							<X className="text-white p-0 cursor-pointer"
								width={26}
								height={26}/>
						</button>
					</div>}

				<FilterModal customUrlBaseValue={customUrlBaseValue}
					collectionName={collectionName}
					productsPriceRange={isAccessoriesPage ? accessoriesPriceRange : productsPriceRange}
					filters={filters}
					handleClose={handleClose}
					isOpen={isOpen}/>
				{isEmptySearch ? <BasedOnYourViews/> : children}
			</div>
			<div ref={refToStartOfCollection}
				className=" d-none d-md-block"
				style={{maxWidth: 1890, margin: "0 auto", padding: "0px 72px"}}>
				<div className="row justify-content-between gx-5">
					<div className={`col-md-3 col-lg-3 col-xl-2 text-nowrap ${isBrandWorld ? "" : "sticky-filters"}`}>
						<FilterVerticalSection
							productsPriceRange={priceRange}
							customUrlBaseValue={customUrlBaseValue}
							filters={filters}
							collectionName={collectionName}
							collectionCategory={collectionCategory}
							filteredProductsLength={filteredProductsLength}
							products={productsList}/>
					</div>
					<div className="col-md-9 col-lg-9 col-xl-10 pe-0"
						style={{paddingLeft: 32}}>
						{brandsArray.length === 1 && !isBrandWorld &&
						<div className="mb-4">
							<BrandInfoPLP selectedBrand={brandsArray[0]}
								selectedCategory={selectedCategory}/>
						</div>}
						{isEmptySearch ? <EmptySearchResults/> : <>
							<BannerForPartners/>
						</>}
						{isEmptySearch ?
							<div className="col-12 py-4 d-flex justify-content-center align-items-center">
								<Typography style={{fontSize: "36px", lineHeight: "44px", marginBottom: "1rem", marginTop: "2rem"}}
									variant="bodyLgBlack">{t("recommendation-for-you-tag")}</Typography></div> : null}
						<FilterHorizontalSection isLoading={isLoading}
							collectionName={collectionName}
							filteredProductsLength={filteredProductsLength}
							categories={filteredHorizontalCategories}
							accessoryCategories={accessoryFilters?.filter(attribute => attribute.slug === "accessory-type")[0]}/>
						{isEmptySearch ? <BasedOnYourViews/> : children}
					</div>
				</div>
			</div>
		</>
	)
}

export default FilterBar
